module.exports = __webpack_public_path__ + "static/media/Ecommerce.9301e262.svg";